import styled from 'styled-components';

import { Flexer } from '@ontruck/orc';

const StyledContainer = styled(Flexer.Parent).attrs(() => ({
  p: 'S',
  pTop: 'N',
}))`
  & + & {
    border-top: 1px solid var(--greyWolf);
  }
`;

const StyledChild = styled(Flexer.Child).attrs(() => ({
  mRight: 'S',
  mTop: 'S',
}))``;

export { StyledContainer, StyledChild };
